import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function VideoThumbnail(props) {
  const { src, onClick, title } = props;

  return (
    <Root onClick={onClick}>
      <ThumbnailWrapper>
        <Thumbnail src={src} alt="thumbnail" />
        <PlayIcon src={require('assets/images/icons/play.png')} alt="play" />
      </ThumbnailWrapper>
      <p>{title}</p>
    </Root>
  )
}

VideoThumbnail.propTypes = {
  src: PropTypes.any,
  onClick: PropTypes.func
}

const Root = styled.div`
  cursor: pointer;

  ${vw('padding', 10)}

  > p {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #252525;
    transition: all 0.25s;

    ${vw('font-size', 10, 14)}
    ${vw('line-height', 18, 25)}
  }
`;

const ThumbnailWrapper = styled.div`
  position: relative;
`;

const Thumbnail = styled.img`
  width: 100%;
  height: auto;
`;

const PlayIcon = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 9;

  ${vw('width', 30, 40)}
  ${vw('height', 30, 40)}
`;

export default VideoThumbnail
